<script>
import NavigationToolbar from '@components/navigation-toolbar.vue'
import texts from '../../assets/data/localisations.json'
import Vue from 'vue'

export default {
  components: { NavigationToolbar },
  data() {
    return {
      texts: null,
    }
  },
  computed: {
    params() {
      return this.$store.getters['globals/params']
    },
    allTopics() {
      return this.$store.getters['topics/filteredTopics']
    },
    allMessages() {
      return this.$store.getters['topics/allMessages']
    },
    platform() {
      return this.$store.getters['globals/platform']
    },
    appStatus() {
      return this.$store.getters['globals/status']
    },
    locale() {
      return this.$store.getters['globals/locale']
    },
    mlApp() {
      return this.$store.getters['globals/mlApp']
    },
    hyperdotApp() {
      return this.$store.getters['globals/hyperdotApp']
    },
    suportLink() {
      if (this.mlApp) {
        return 'https://support.mythic-legends.com/'
      } else {
        return 'https://outfit7.com/game-support/'
      }
    },
  },
  watch: {
    appStatus(val) {
      if (this.appStatus === 'error') {
        setTimeout(() => {
          window.location.href = this.suportLink
        }, 5000)
      }
    },
  },
  created() {
    this.texts = texts
    // if Query parameters are provided, save them to state so we can call required services
    if (
      Object.entries(this.$route.query).length > 0 &&
      this.$route.query.constructor === Object
    ) {
      if (this.$route.query.test) {
        this.$store.dispatch('globals/testParams', this.$route.query)
        console.log('TEST PARAMS')
      } else {
        this.setCookie("o7_usersupport", JSON.stringify(this.$route.query), 30)
        this.$store.dispatch('globals/updateParams', this.$route.query)
        console.log('UPDATE PARAMS')
      }
    } else {
      const query = this.getCookie("o7_usersupport")
      if (query) {
        this.$store.dispatch('globals/updateParams', JSON.parse(query))
        console.log('UPDATE PARAMS')
      }
    }
    // on /discord-consent route, check for o7_discordscreen cookie
    // if present it means user already gave/skipped consent today (probably navigating back from discord)
    // we need to show him the faq page instead
    if (this.$route.name === 'discord-consent') {
      const ds = this.getCookie("o7_discordscreen")
      if (ds) this.$router.push({ name: 'faq' })
    }
    // fetch only if we're missing topics
    if (this.allTopics.length === 0) {
      if (this.params.u || this.params.minimalRequest) {
        this.$store.dispatch('topics/fetchTopics')
      } else {
        this.$store.dispatch('globals/updateStatus', 'error')
        Vue.$plausible.trackEvent('Error', {
          props: {
            eventCategory: 'Error',
            eventAction: 'Params not set',
            eventLabel: 'Fetch topics failed'
          }
        })
      }
    }
    if (this.allMessages.length === 0) {
      if (this.params.u) {
        // populate initial message
        if (this.hyperdotApp) {
          this.dispatchMessage(texts[this.locale].hyperdotwelcome, false, true)
        } else {
          this.dispatchMessage(texts[this.locale].supportwelcome, false, true)
        }
        // fetch messages (we need to have them ready before user switches to chat)
        this.$store.dispatch('topics/fetchMessages')
      } else {
        if (!this.params.minimalRequest) {
          this.$store.dispatch('globals/updateStatus', 'error')
          Vue.$plausible.trackEvent('Error', {
            props: {
              eventCategory: 'Error',
              eventAction: 'Params not set',
              eventLabel: 'Fetch topics failed'
            }
          })
        }
      }
    }
  },
  methods: {
    setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	  },
	  getCookie(cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) === 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	  },
    dispatchMessage(message, ug, isLocal) {
      // messages that are 'pushed' were sent to support, but we don't have the confirmation yet that they were received.
      // pushed messages are only stored in the display queue and will be overwritten when we receive a new conversation list from the server
      // non-pushed messages are local messages which are not sent to server and are stored only for this session. These messages will be displayed throughout the session.
      this.$store.dispatch('topics/postLocalMessage', {
        body: message,
        userGenerated: ug,
        local: isLocal,
      })
      if (ug) {
        this.$store.dispatch('topics/postMessage', {
          body: message,
        })
      }
    },
  },
}
</script>

<template>
  <div v-if="appStatus === 'success'" :class="['appcontainer', locale, mlApp ? 'mythiclegends' : 'outfit7']">
    <NavigationToolbar></NavigationToolbar>
    <div id="appcontent" class="appcontent">
      <slot />
    </div>
  </div>
  <div v-else-if="appStatus === 'init'">
    <div class="loading">
      <span class="loadingmessage">{{ texts[locale].connecting }}</span>
      <md-progress-spinner
        :md-diameter="80"
        :md-stroke="6"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
  </div>
  <div v-else>
    <md-card>
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">{{ texts[locale].oops }}</div>
        </md-card-header-text>
      </md-card-header>

      <md-card-content>{{ texts[locale].redirected }}</md-card-content>

      <md-card-actions md-alignment="left">
        <md-button class="md-raised md-primary" :href="suportLink">{{
          texts[locale].goonline
        }}</md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: 'Amsi Pro Cond';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url('../../assets/fonts/AmsiProCond-Black.woff') format('woff');
}

@font-face {
  font-family: 'Roboto Condensed';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url('../../assets/fonts/RobotoCondensed-Regular.ttf') format('ttf');
}

@font-face {
  font-family: 'Roboto Condensed';
  font-style: normal;
  font-weight: bold;
  font-display: swap;
  src: url('../../assets/fonts/RobotoCondensed-Bold.ttf') format('ttf');
}

@font-face {
  font-family: 'Roboto Condensed';
  font-style: italic;
  font-weight: normal;
  font-display: swap;
  src: url('../../assets/fonts/RobotoCondensed-Italic.ttf') format('ttf');
}

@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('../../assets/fonts/RobotoMono-SemiBold.ttf') format('ttf');
}




html.md-theme-default {
  background-color: #fff;
}

html:has(.mythiclegends),
body:has(.mythiclegends),
#app:has(.mythiclegends) {
  background-color: #fdf0d7;
}

.appcontainer {
  position: relative;
  max-width: 100%;
  margin: 0 auto;

  &.ar {
    direction: rtl;
  }

  &.mythiclegends {
    background: #fdf0d7;

    /* height: 100vh; */
    .md-toolbar.md-theme-default.md-primary,
    .md-button.md-theme-default.md-raised:not([disabled]).md-primary,
    .md-button.md-theme-default.md-fab:not([disabled]).md-primary {
      background-color: #151515;
      color: #ffffff;
    }

    .md-field.md-theme-default:before {
      border-color: #151515;
    }

    .md-field.md-theme-default.md-focused label {
      color: #151515;
    }

    .md-button.md-theme-default.md-primary,
    .md-theme-default a:not(.md-button) {
      color: #151515;
    }

    .md-toolbar.md-theme-default.md-primary .md-title,
    .md-toolbar.md-theme-default.md-primary .md-display-1,
    .md-toolbar.md-theme-default.md-primary .md-display-2 {
      color: #ffffff;
    }

    .chat-container .conversation-container .message.card-left .card {
      background-color: #e8caa4;
      color: rgba(0, 0, 0, 0.87);
    }

    .chat-container .conversation-container .message.card-right .card {
      background-color: #eac28b;
      color: rgba(0, 0, 0, 0.87);
    }

    .appcontent {
      background: #fdf0d7;

      .md-list.md-theme-default {
        background: #fdf0d7;
      }
    }

    .feedback {
      background: #fdf0d7;
    }
  }
}

.appcontent {
  position: relative;
  margin-top: 56px;
  padding: env(safe-area-inset-top) 0 0 0;
  width: 100%;
  z-index: 2;
  background: #fff;

  @media screen and (min-width: 760px) {
    margin-top: 100px;
  }
}

.loading {
  padding-top: 40%;

  .loadingmessage {
    display: block;
    margin: 0 auto;
    width: auto;
    text-align: center;
  }

  >div {
    left: 50%;
    margin-top: 30px;
    margin-left: -40px;
  }
}

.chatbutton {
  position: fixed !important;
  bottom: 10px;
  right: 10px;

  &.android,
  &.fbck {
    bottom: 60px;
  }
}

.badge {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -10px;
  right: -10px;
  background: #ff5252;
  border-radius: 100%;
  color: #fff;
  font-size: 11px;
  line-height: 11px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.05em;
  font-family: 'Roboto Mono', monospace;
  z-index: 10;

  &.show {
    display: flex;
  }

  &.hide {
    display: none;
  }
}
</style>
